import { render, staticRenderFns } from "./AisMenuDropdown.vue?vue&type=template&id=740c39ca&scoped=true&"
import script from "./AisMenuDropdown.vue?vue&type=script&lang=js&"
export * from "./AisMenuDropdown.vue?vue&type=script&lang=js&"
import style0 from "./AisMenuDropdown.vue?vue&type=style&index=0&id=740c39ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740c39ca",
  null
  
)

export default component.exports